export default "__VITE_ASSET__B2CG9aV0__"